import React from "react";
import LegendEdit from "views/content/LegendEdit";

export default function LegendView() {
  return <LegendEdit readOnly />;
}
